module.exports = __webpack_public_path__ + "img/icon_newsletter.d5598391.svg";